import { useContext } from 'react';
import { ReportContext } from '../../../context/ReportContext';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import SimpleDataGrid from '../../Tables/SimpleDataGrid';
import SimpleDataGridItem from '../../Tables/SimpleDataGridItem';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserCoursesAggregate = () => {
    const { reportData } = useContext(ReportContext);

    const data = reportData || {};
    const breakdown = Array.isArray(data.courseBreakdown) ? data.courseBreakdown : [];

    const columns = [
        {
            field: 'courseTitle',
            name: 'Course Title',
            dataType: 'multiselect',
            styles: { minWidth: '20rem' },
        },
        {
            field: 'coursesStarted',
            name: 'Courses Started',
            dataType: 'numeric',
        },
        {
            field: 'coursesCompleted',
            name: 'Courses Completed',
            dataType: 'numeric',
        },
        {
            field: 'averagePreScore',
            name: 'Average Pre Score',
            dataType: 'numeric',
        },
        {
            field: 'averagePostScore',
            name: 'Average Post Score',
            dataType: 'numeric',
        },
    ];

    return (
        <div className="space-y-6">
            <div>
                <SimpleDataGrid>
                    <SimpleDataGridItem
                        label="Total Courses Started:"
                        value={data.totalCoursesStarted}
                    />
                    <SimpleDataGridItem
                        label="Total Courses Completed:"
                        value={data.totalCoursesCompleted}
                    />
                    <SimpleDataGridItem
                        label="Average Pre Score:"
                        value={data.averagePreScore}
                    />
                    <SimpleDataGridItem
                        label="Average Post Score:"
                        value={data.averagePostScore}
                    />
                </SimpleDataGrid>
            </div>

            <StandardizedDataTable data={breakdown} columns={columns} />

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report provides an aggregate view of courses started, completed,
                    and performance metrics for the selected time period and filters.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Total Courses Started">
                    The total number of courses that users have started.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Total Courses Completed">
                    The total number of courses that users have finished.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Average Pre Score">
                    The average score on pre-course assessments, which measure knowledge
                    before course completion.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Average Post Score">
                    The average score on post-course assessments, which measure knowledge
                    after course completion.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Course Breakdown Table">
                    A detailed breakdown showing starts, completion, and assessment scores
                    for each individual course.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserCoursesAggregate;
